import { DebugService } from '../../../shared/services/debug.service.js';
import { REFI_PERSONAL_CONST } from '../../../shared/constants/app.constants.js';
import { ApplicationService } from '../../../services/application.service';

class _SessionService {
  constructor() {
    this.debug = new DebugService('SessionService');
    this.sessionStorageKey = REFI_PERSONAL_CONST.REFI_SESSION_KEY;
    this.sessionStorageKeyV2 = REFI_PERSONAL_CONST.REFI_SESSION_KEY_V2;
    this.offerStorageKey = 'auto-refi-offerkey';
  }

  get session() {
    if (ApplicationService.isV2Routing) {
      return JSON.parse(sessionStorage.getItem(this.sessionStorageKeyV2))?.state
        ?.currentSession;
    }
    return JSON.parse(sessionStorage.getItem(this.sessionStorageKey));
  }

  getCachedOffer() {
    const offerString = localStorage.getItem(this.offerStorageKey);
    if (!offerString) {
      return null;
    }
    let offer = JSON.parse(offerString);
    if (ApplicationService.isV2Routing) {
      offer = ApplicationService.Application?.cachedOffer || offer;
    }
    if (!offer.expirationDate) {
      return null;
    }
    if (!this.isOfferStillValid(new Date(offer.expirationDate))) {
      offer = null;
      this.removeCachedOffer();
      this.debug.log('offer expired');
    }
    return offer;
  }

  isOfferStillValid(expirationDate) {
    const currentdate = new Date();
    if (!expirationDate || expirationDate < currentdate) {
      return false;
    }
    return true;
  }

  removeCachedOffer() {
    this.debug.log('removing access code offer');
    localStorage.removeItem(this.offerStorageKey);
    sessionStorage.removeItem(this.offerStorageKey);
    if (ApplicationService.isV2Routing) {
      ApplicationService.Application = {
        ...ApplicationService.Application,
        cachedOffer: null,
      };
    }
  }
}

export const SessionService = new _SessionService();
